/** Mesure d'audience : événement DOM « xp-analytics », dataLayer (GTM) et/ou envoi groupé vers un endpoint. */
export class Analytics {
  constructor(host, cfg = {}) {
    this.host = host; this.cfg = cfg; this.queue = []; this.session = Math.random().toString(36).slice(2, 10);
    this.t0 = performance.now();
    this.onHide = () => this.flush(true);
    addEventListener('pagehide', this.onHide);
    this.timer = setInterval(() => this.flush(), 15000);
  }
  track(type, data = {}) {
    const ev = { type, project: this.cfg.project || null, ...data, session: this.session, ts: Date.now(), t: Math.round(performance.now() - this.t0) };
    this.host.dispatchEvent(new CustomEvent('xp-analytics', { detail: ev, bubbles: true, composed: true }));
    if (this.cfg.dataLayer) (window.dataLayer = window.dataLayer || []).push({ event: 'xp_' + type, xp: ev });
    if (this.cfg.endpoint) this.queue.push(ev);
  }
  /** Envoi groupé (webhook n8n xp-collect). En fermeture de page : sendBeacon en text/plain (pas de pré-requête CORS). */
  flush(final = false) {
    if (!this.cfg.endpoint || !this.queue.length) return;
    const body = JSON.stringify({ events: this.queue.splice(0) });
    try {
      if (final && navigator.sendBeacon) navigator.sendBeacon(this.cfg.endpoint, new Blob([body], { type: 'text/plain' }));
      else fetch(this.cfg.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
    } catch {}
  }
  destroy() { this.flush(true); clearInterval(this.timer); removeEventListener('pagehide', this.onHide); }
}
